import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import zibea from "../../Assets/Projects/zibea.png";
import emotion from "../../Assets/Projects/emotion.png";
import rfid from "../../Assets/Projects/rfid.png";
import gesa from "../../Assets/Projects/gesa.png";
import suicide from "../../Assets/Projects/suicide.png";
import cutClear from "../../Assets/Projects/cut.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
        Here are a few recent projects that I worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gesa}
              isBlog={false}
              title="Gesa Medical Aid"
              description="Gesa Medical Supliers which developed using wordpress. Have features which allows user for realtime messaging, product search as well as supports reactions on messages."
              ghLink=""
              demoLink="https://gesamedical.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cutClear}
              isBlog={false}
              title="Android Based Online Clearance System"
              description="The Chinhoyi University of Technology require payment for the clearance of former students
              thus the system was integrated with Paynow for funds transfer to facilitate online payments.
              Iterative method was used for the development of this module where we created increments
              of this module."
              ghLink="https://github.com/tenacious1/"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={rfid}
              isBlog={false}
              title="Attendance System"
              description="In this project, we have designed search RFID RC522 Based Attendance System Using search Arduino with Data Logger. search MFRC522 RFID Reader is a very simple yet effective module. It is an RFID module and is used for scanning RFID cards. It’s a new technology and is expanding day by day. "
              ghLink="https://github.com/tenacious1/"
              demoLink=""              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={zibea}
              isBlog={false}
              title="Website : Zibea"
              description="Biomedical Engineering Technology. Their website features their wall art and medical training which uplifts the whole design . Their website store fun to browse and is powered by WooCommerce."
              ghLink=""
              demoLink="https://zibea.co.zw/"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col> */}

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
